(function ($) {
	var ui = kendo.ui,
		Widget = ui.Widget;
	/**
	 * inputRegex - izraz koji mora na kraju biti zadovoljen da bi bio ispravan
	 * inputRegexIncomplete - izraz koji je na putu da bude ispravan 
	 * 		npr. 
	 * 		1. samo zadamo "do" što je neispravan izraz: .. 
	 * 		2. naknadnim zadavanjem konkretne vrijednosti, npr. 31.12.2014 dobili smo valjani izraz: .. 31.12.2014
	 * 
	 * */
	var inputRegex = /^((vdv|dv|vd|v)(a(vdv|vd|dv|v)?)*)?$/;
	var inputRegexIncomplete = /^(d|(vdv|vd|dv|v)(a(vdv|vd|dv|v))*(ad?)?)$/;
	
	function AddOperator() {
		
	}
	
	function UntilOperator() {
		
	}
	
	function ItemValue(value, caption, text) {
		this.value = value;
		this.caption = caption;
		this.text = text;
	}
		
	var KontoIspis = Widget.extend({
		init: function (element, options) {
			var that = this;
			Widget.fn.init.call(that, element, options);
			
			that.element = $(element);
			that._createElement();
			that._bindEvents();
		},
		options: {
			name: "Ispis",
			change: function () { }
		},
		/**
		 * Parametri:
		 * 
		 * inputType - tip inputa koji određuje ponašanje elementa (date, int, string, sifarnik)
		 * dataType - tip podatka inputa - koristi se kod šifarnika koji može imati int i string tip.
		 * 		Za ostale tipove je jasan tip podatka.
		 * uppercase - da li se radi uppercase slova unutar kućice
		 * itemRegex - regex kojim provjeravamo sadržaj kućice, označava dozvoljeni izraz unutar kućice. 
		 * 		Npr. [K|D]\d+ označava da možemo upisati K0001, D1234 itd. ali ne možemo upisati B0923, 2135 i slično.
		 * 
		 * U slučaju inputType šifarnika, bitni su sljedeći parametri:
		 * path - putanja do šifarnika
		 * searchColumn (param: col-filter) - stupac po kojemu se pretražuje prilikom poziva šifarnika (ako je nešto zadano u kućici)
		 * 		default: "NAZIV"
		 * pkColumn - primarni ključ
		 * dsMethod - metoda koja se poziva nakon što se utipka nešto u kućicu i stisne enter. Npr. to je KontoById. 
		 * ds-method-param: parametri za gornju metodu
		 * */
		_createElement: function () {
			var that = this;
			
			that.element.addClass("input-group konto-ispis-input");
			that.searchColumn = that.element.data("col-filter") || "NAZIV";
			that.pkColumn = that.element.data("pk-column");
			that.dsMethod = that.element.data("ds-method");
			that.dsMethodParam = that.element.data("ds-method-param");
			that.onlyOneElement = that.element.data("allow-only-one-element");
			that.name = that.element.data("name");	
			that.vratiItem = true;		
			
			that.dataType = that.element.data("type") || "string";
			that.uppercase = that.element.data("uppercase") === true;
			that.inputType = that.element.data("input") || "sifarnik";
			// Sifarnik ima varijabilni dataType, sve ostalo je fiksno.
			switch (that.inputType) {
			case "date": 
					that.dataType = "date";
					break;
			case "int":
					that.dataType = "int";
					break;
			case "string":
					that.dataType = "string";
					break;
			}
			
			that.itemRegex = that.element.data("regex");
			if (!that.itemRegex) {
				switch (that.dataType) {
				case "date":
					that.itemRegex = /\d+/;
					break;
				case "int":
					that.itemRegex = /^\d+$/;
					that.terminatorRegex = /[-,\.]/;
					break;
				case "string":
					// sve osim whitespace...
					//Privremeno dodao whitespace - Tiho 24.07.2017 - zbog potreba za šifre artikla u BA
					that.itemRegex =  /^[^\v\b]+$/; // /^[^\s\v\b]+$/;  // /^\S+$/;
					break;
				}
			}
			
			// shorthand atribut
			that.isSifarnik = that.inputType == "sifarnik";
			
			// Items kolekcija
			that.items = $("<ul>");
			that.items.addClass("items");
			that.items.addClass("form-control");
			// U slučaju nepostojanja od do buttona s desne su strane oštri rubovi. To se ispravlja ovim CSS-om.
			// Ovo je privremeno rješenje. Definitivno treba napraviti u CSS-u ili LESS-u.
			if (!(that.isSifarnik || that.inputType == "date")) {
				that.items.css("border-bottom-right-radius", "4px");
				that.items.css("border-top-right-radius", "4px");
			}
			
			// Hidden input u kojeg spremamo vrijednost cijelog inputa koja će se slati na server.
			that.input = $("<input>");
			that.input.attr("type", "hidden");
			that.input.attr("name", that.element.data("name"));
			that.input.val("");
			
			// Hidden checkbox za NULL parametar
			that.cbNull = $("<input>");
			that.cbNull.attr("type", "hidden");
			that.cbNull.attr("id", that.element.data("name") + 'Null');			
			that.cbNull.attr("name", that.element.data("name") + 'Null');
			that.cbNull.val('0');
							
			// Filter element je input u kojeg upisujemo tekst, npr. UF. Tek pritiskom na enter se upiše u input koji se šalje na server.
			that.filter = $("<input>");
			that.filter.attr("type", "text");
			that.filter.addClass("filter-input");
			
			
			// Dorada maske za datumska polja.
			if (that.inputType == "date") {
				that.filter.kendoMaskedTextBox({
					mask: "",
					culture: "en-US",
				});	
				that.filter.removeClass("k-input-inner");
			}
			
			
			// Disable paste-anja zbog otežane validacije.
			that.filter.on("paste", function (event) {
				event.preventDefault();
			});
			
			/**
			 *  Zajedničko za sve tipove inputa:
			 *  Brisanje na backspace ili delete
			 *  
			 *  Dodavanje na enter samo za šifarnik?
			 *  
			 *  */
			that.filter.keydown(function (event) {
				if (event.keyCode == 8 || event.keyCode == 46) {
					if ($(this).val() == "") {
						that._removeLast();
					}
				}
			});
			
			that.itemFilter = $("<li>");
			that.itemFilter.addClass("item-filter");
			that.itemFilter.append(that.filter);
			that.items.append(that.itemFilter);
			
			// Poredak je bitan zbog border radiusa.
			that.element.append(that.items);
			that.element.append(that.input);
			that.element.append(that.cbNull);			
			if (that.isSifarnik || that.inputType == "date") {
				that._kreirajOdDoButtone();				
			}
			
			that.items.on("click focus", function (event) {
				if (event.target === that.items.get(0)) {
					that.filter.focus();
				}
			});
			
			// Nakon što smo elemente kreirali i dodali u DOM.
			that._initDateButtons();
			
			// Null Button stavljamo na sve
			
			var _prikaziNull = false;
			if (typeof that.element.data('prikazi-null') != 'undefined') {
				_prikaziNull = that.element.data('prikazi-null');					
			}				
			if(_prikaziNull){
				that._kreirajButtonNull(that.element.data("name") + 'Null');	
			}			
						
			//Delete button stavljamo na sve, ne samo na sifarnik i date
			that._kreirajButtonDelete();
		},
		_postaviNullNaDefault: function () {	
			var el = $('#' + this.element.data("name") + 'Null');
			var inel = $('#' + this.element.data("name") + 'NullButton');			
			el.val('0');	
			inel.html("<i class='far fa-circle'>");
		},
		_kreirajButtonDelete: function () {
			var that = this;
			that.opDel = $("<span>");
			that.opDel.addClass("input-group-append");
			that.opDelT = $("<span>");
			that.opDelT.addClass("del input-group-text");
			that.opDelT.html("<i class='far fa-trash-alt'>");			
			that.opDelT.appendTo(that.opDel);
			
			that.element.append(that.opDel);
		},
		_kreirajButtonNull: function (hiddenId) {
			var that = this;
			
			that.opNull = $("<span>");
			that.opNull.addClass("input-group-append");
			that.opNullT = $("<span>");
			that.opNullT.addClass("input-group-text");
			that.opNullT.attr("id", that.element.data("name") + 'NullButton');				
			that.opNullT.html("<i class='far fa-circle'>");			
			that.opNullT.appendTo(that.opNull);
			
			that.opNull.attr("title", "Stavke bez ovog podatka");
						
			that.opNull.click(function(){
				var el = $(this).closest('.form-group').find('#' + hiddenId);
				var inel = $(this).find(".input-group-text").first();
				
				if(el.val() == '1'){
					el.val('0');	
					inel.html("<i class='far fa-circle'>");
				}
				else {
					el.val('1');
					inel.html("<i class='far fa-check-circle'>");					
				}
			});			
			
			that.element.append(that.opNull);
		},		
		/**
		 * Kreiranje od, do i + buttona za šifarnik i datume.
		 * */
		_kreirajOdDoButtone: function () {
			var that = this;
			
            if (that.inputType == "date"){
                var classIGT = "";        
            }else{
                var classIGT = "input-group-text";     
            }
			
			that.opFrom = $("<span>");
			that.opFrom.addClass("input-group-append");
			that.opFromT = $("<span>");
			that.opFromT.addClass("from " + classIGT);
			that.opFromT.html("od");			
			that.opFromT.appendTo(that.opFrom);

			
			that.opUntil = $("<span>");
			that.opUntil.addClass("input-group-append");
			that.opUntilT = $("<span>");
			that.opUntilT.addClass("until " + classIGT);
			that.opUntilT.html("do");			
			that.opUntilT.appendTo(that.opUntil);
			
			that.opAdd = $("<span>");
			that.opAdd.addClass("input-group-append");
			that.opAddT = $("<span>");
			that.opAddT.addClass("or " + classIGT);
			that.opAddT.html("+");			
			that.opAddT.appendTo(that.opAdd);

			that.element.append(that.opFrom);
			that.element.append(that.opUntil);
			that.element.append(that.opAdd); 
		},
		_bindEvents: function () {
			var that = this;
			
			if (that.inputType == "date") {
				that.opAdd.click(function (event) {
					event.stopPropagation();
					that.dpAdd.open();
				});
				
				that.opFrom.click(function (event) {
					event.stopPropagation();
					that.dpFrom.open();
				});
				
				that.opUntil.click(function (event) {
					event.stopPropagation();
					that.dpUntil.open();
				});
				
				//that.opNull.click(function (event) {
				//	event.stopPropagation();
				//	that.opNull.click();
				// });
								
				that.opDel.click(function (event) {
					event.stopPropagation();
					that.clear();
				});
				
				that.filter.keypress(function (event) {
					var c = String.fromCharCode(event.which);
					var val = $(this).val();
					if (val === "__.__.____") {
						$(this).val("");
						val = "";
					}
					
					// Ako postoji nešto unutra, mogu upisivati samo brojeve.
					if (val.length > 0) {
						return that.itemRegex.test(c);
					}
					
					// Za datum može biti "-", "," ili broj
					var reg = that._getItemsRegex();
					if (c == "-")
						reg += "d";
					else if (c == ",")
						reg += "a";
					else if (that.itemRegex.test(c))
						reg += "v";
					else if (!KUtils.isKeyCodePrintable(event.keyCode))
						return;
					else
						return false;
					
					if (!inputRegexIncomplete.test(reg)) {
						return false;
					}
					
					if (c == "-" || c == ",") {
						that._addOp(c == "," ? "add" : "until");
						$(this).val("");
						// Nemoj staviti znak u input.
						return false;
					}
					else { // c je broj (početak datuma)
						var maskedTB = that.filter.data("kendoMaskedTextBox");
						var maskOpt = {
							mask: "00.00.0000",
							culture: "en-US"
						};						
						maskedTB.setOptions(maskOpt);					
					}
				});
				
				that.filter.keyup(function (event) {					
					var val = $(this).val();
					var date = kendo.parseDate($(this).val());
					if (date != null) {
						that._addItem(date);
					}
					if (date != null || val == "" || val == "__.__.____") {
						var maskedTB = that.filter.data("kendoMaskedTextBox");
						var maskOpt = {
							mask: "00.00.0000",
							culture: "en-US"
						};						
						maskedTB.setOptions(maskOpt);
						$(this).val("");
					}
				});
			}
			if (that.inputType == "string" || that.inputType == "int" || that.isSifarnik) {
				function filterExit() {
					var $this = $(this);
					if (that.isSifarnik) {
						var val = $this.val();
						if (val != "") {
							var reg = that._getItemsRegex();
							// Ima smisla samo ako mogu dodati value.
							if (that.isValid(reg + "v")) {
								that._getById($this.val())
									.then(function(value) {
										if (value)
											$this.val("");
										else {
											that._dohvatiSifarnik(function (data) {
												that._addItem(data);
											});
										}	
									});
							}
						}
					}
					else {
						var val = $this.val();
						if (val != "") {
							if (that.inputType == "string")
							{
								that._addItem(val);
							}								
							else {
								var i = parseInt(val);
								that._addItem(i);
							}
							$this.val("");
						}
					}
				}
				
				that.filter.keyup(function (event) {
					if (event.keyCode == 13) {
						filterExit.call(this);
					}
				});
				that.filter.blur(filterExit);
				
				if (that.isSifarnik) {
					that.opAdd.click(function () {
						that._dohvatiSifarnik(function (data) {
							that._onOdabir(data, "add");
							if(that.onlyOneElement){
								that.hideButtons();
							}
						});
					});
					
					that.opFrom.click(function () {
						var jeMinus = false;
						var elems = $(that.items[0]).find('li');
						if(elems.length > 2){
							var lastElem = elems[elems.length -2];
							if($(lastElem).hasClass('operator until')){
								jeMinus = true;
							}
						}

						var reg = that._getItemsRegex();
						reg += "vd";
						if ((!that.isValid(reg)) && jeMinus)
							return;
						that._dohvatiSifarnik(function (data) {
							that._onOdabir(data, "from");
							if(that.onlyOneElement){
								that.opAdd.addClass("hide");
								that.opFrom.addClass("hide");
							}							
						});
					});
					
					that.opUntil.click(function () {
						// Da vidim mogu li dodati ovaj operator.
						var reg = that._getItemsRegex();
						if (that.isValid(reg + "dv") || 
							(reg.length > 0 && (reg[reg.length - 1] == "d") && 
									that.isValid(reg + "v"))) {
							that._dohvatiSifarnik(function (data) {
								that._onOdabir(data, "until");
								if(that.onlyOneElement){
									that.hideButtons();
								}								
							});
						}
					});
				}
				
				//izvan svih ifova jer je na svim tipovima polja
				that.opDel.click(function () {
					that.clear();
				});
				
				that.filter.keypress(function (event) {
					/**
					 * Firefox ovdje šalje i neprintabilne charactere (strelice, enter itd).
					 * U tom je slučaju which = 0. U ostalim browserima se event ne triggera.
					 */
					if (event.which === 0)
						return;				
					
					// Backspace i enter nemoj obrađivati. Enter je na keyup.
					if (event.which === 8 || event.which === 13)
						return;
					
					var c = String.fromCharCode(event.which);
					var val = $(this).val();
					if (that.terminatorRegex && that.terminatorRegex.test(c)) {
						filterExit.call(this);
						val = "";
					}
					
					// Kad je prazan, provjerava se nova vrijednost.
					if (val.length == 0) {
						if (c == ".")
							c = "-";
						
						var reg = that._getItemsRegex();
						if (c == "-")
							reg += "d";
						else if (c == ",")
							reg += "a";
						else if (that.itemRegex.test(c))
							reg += "v";
						else
							return false;
	
						if (!inputRegexIncomplete.test(reg)) {
							return false;
						}	
						
						if (c == "-" || c == ",") {
							that._addOp(c == "," ? "add" : "until");
							$(this).val("");
							// Da se ne izvrši uppercase keypress event.
							event.stopImmediatePropagation();
							// Ako je terminator operator, dodali smo ga gore. 
							// Zanemari znak.
							return false;
						}
						return true;
					}
					else {
						// Provjera da li je izraz još uvijek validan.
						return that.itemRegex.test(val + c);
					}
				});
			}
			if (false && that.isSifarnik) {
				that.filter.keyup(function (event) {
					var val = $(this).val();
					if (val == ".." || val == "-" || val == ",") {
						var reg = that._getItemsRegex();
						if (val == ".." || val == "-")
							reg += "d";
						else /* val == "," */
							reg += "a";
						if (inputRegexIncomplete.test(reg)) {
							that._addOp(val == "," ? "add" : "until");
						}
						$(this).val("");
						/*
						if (that.isValid(reg) || reg == "d") {
							that._addOp(val == "," ? "add" : "until");
							$(this).val("");
						}
						*/
					}
				});
				
				that.opAdd.click(function () {
					that._dohvatiSifarnik(function (data) {
						that._onOdabir(data, "add");
					});
				});
				
				that.opFrom.click(function () {
					var reg = that._getItemsRegex();
					reg += "vd";
					if (!that.isValid(reg))
						return;
					that._dohvatiSifarnik(function (data) {
						that._onOdabir(data, "from");
					});
				});
				
				that.opUntil.click(function () {
					// Da vidim mogu li dodati ovaj operator.
					var reg = that._getItemsRegex();
					if (that.isValid(reg + "dv") || 
						(reg.length > 0 && (reg[reg.length - 1] == "d") && 
								that.isValid(reg + "v"))) {
						that._dohvatiSifarnik(function (data) {
							that._onOdabir(data, "until");
						});
					}
				});
				
				that.opDel.click(function () {
					that.clear();
				});
			}
			
			// Ovaj event dolazi na kraju, nakon što su se izveli keypress eventi od inputa (provjera ispravnosti).
			if (that.uppercase) {
				that.filter.keypress(function (event) {
					var c = String.fromCharCode(event.which);
					var newVal = $(this).val();
					newVal += c.toUpperCase();
					$(this).val(newVal);
					return false;
				});
			}
		},
		_initDateButtons: function () {
			var that = this;
			if (that.inputType == "date") {
				that.dpAdd = that._initDateButton(that.opAdd, function () {
					that._onOdabir(this.value(), "add");
				});				
				
				that.dpFrom = that._initDateButton(that.opFrom, function () {
					that._onOdabir(this.value(), "from");
				});
				
				that.dpUntil = that._initDateButton(that.opUntil, function () {
					that._onOdabir(this.value(), "until");
				});
			}			
		},
		_initDateButton: function (el, onChange) {			
			var that = this;
			el.kendoDatePicker({
				change: onChange,
                open: function(){
                    this.value(null);
                },
                close: function(){
					if(that.onlyOneElement){
						if((el == that.opAdd) || (el == that.opUntil)){
							that.hideButtons();
						}
						else{
							that.opAdd.parent().addClass("hide");
							that.opFrom.parent().addClass("hide");
						}		
					}                	
                }
			});
			
			
			el.removeClass('k-input-inner');
			var elPar = el.parent();
			elPar.removeClass();
			elPar.addClass('input-group-append');			
					
			var butt = elPar.find('button.k-input-button');
			butt.remove();
		
			/*
			var elGra = elPar.parent();
			var ul = elGra.find('ul.items.form-control')
			
			ul.after(el);
			elPar.remove();
			*/
				
			elPar.click(function (event) {
				event.preventDefault();
				event.stopPropagation();
				el.click();
			});
			
			var fSpan = el.find('span:first');
			fSpan.addClass('input-group-text');
			fSpan.addClass('rounded-0');
			
			var dataKendoPic = el.data("kendoDatePicker");						
			return dataKendoPic;
		},
		// Vraća da li je lista prazna, tj. nema nikakvih kriterija pretraživanja.
		_isEmpty: function () {
			return this.items.find("li.item-value, li.operator").length === 0;
		},
		_isLastItem: function (el) {
			var last = this.items.find("li.operator, li.item-value").last();
			return last[0] && (last[0] == el);
		},
		_getLastItem: function (el) {
			return this.items.find("li.operator, li.item-value").last();
		},
		_onOdabir: function (data, operation) {
			var that = this;

			if (operation == "add") {
				if (!that._isEmpty())
					that._addOp("add");
				that._addItem(data);
			}
			else if (operation == "until") {
				// Već smo dodali operatora?
				var reg = that._getItemsRegex();
				// ako imamo element ispred dodan s add onda dodajemo operator ','
				if ((reg.length > 0 && reg[reg.length - 1] != "d") && (!that.onlyOneElement))
					that._addOp("add");					
				// Ako smo na početku, dodajemo operator do. Ako nismo na početku, dodajemo samo
				// ako nije ispred operator do.
				if (reg.length == 0 || (reg.length > 0 && reg[reg.length - 1] != "d"))
					that._addOp("until");
				that._addItem(data);
			}
			else if (operation == "from") {
				var reg = that._getItemsRegex();
				if (reg.length > 0 && reg[reg.length - 1] != "a") {
					that._addOp("add");
				}
				that._addItem(data);
				that._addOp("until");
			}
			else {
				console.log("Operation '" + operation + "' not supported");
			}
		},
		_getById: function (id) {
			var that = this;
			
			if (typeof that.options.getById === "function") {
			    return that.options.getById.call(that, id);  
			}
			else {
				var deferred = $.Deferred();
    			if (typeof that.dsMethod === "undefined" || $.trim(that.dsMethod) === "" || that.dsMethod === null || 
    				typeof id === "undefined" || $.trim(id) === "" || id === null) {
    				deferred.resolve(false);
    				return deferred;
    			}
    			var value = id;
                var params = [id];
                if (that.dsMethodParam) {
                    var calculatedValue = eval("(" + that.dsMethodParam + ")");
                    if (!$.isArray(calculatedValue))
                        params = [calculatedValue];
                    else
                        params = calculatedValue;
                }   			
    			$.dsDirectCall({
    				method: that.dsMethod,
    				params: params,
    				done: function (data) {
    					if (data) {
    						var newData = $.dsObjectToJS(data);
    						that._addItem(newData);
    						
    						deferred.resolve(true);
    					}
    					else
    						deferred.resolve(false);
    				},
    				error: function (error) {
    					deferred.reject();
    				}
    			});
    			return deferred;
            }
		},
		_getId: function (value) {
			if (this.dataType == "int")
				return parseInt(value);
			else
				return value;
		},
		/**
		 * Postavlja vrijednosti u data objekt od dodanog elementa.
		 * @param item - novi element (li)
		 * @param data - podatak pridružen elementu
		 * 
		 * Pohranjuje se:
		 * id - za šifarnik je to vrijednost ključa, za ostale tipove je upravo ta vrijednost (npr. 15, 18.09.2014, "K0001")
		 * caption - sprema se samo za šifarnike
		 * text - cijeli text unutar elementa
		 * 
		 * */
		_itemSetData: function (item, data) {
			var that = this;
			// _getId dohvaća podatak u ispravnom tipu
			if (!that.isSifarnik)
				item.data("id", that._getId(data));
			if (that.isSifarnik) {
				item.data("id", that._getId(data[that.pkColumn]));	
				var caption = that._getItemCaption(data);
				item.data("caption", caption);
				item.attr("title", caption);
			}
			
			var text = item.find(".item-caption");
			var itemText = that._getItemText(data);
			item.data("text", itemText);
			text.html(itemText);
		},
		_itemSetDataFromCache: function (item, cacheValue) {
			var that = this;
			item.data("id", cacheValue.value);
			if (cacheValue.caption) {
				item.data("caption", cacheValue.caption);
				item.attr("title", cacheValue.caption);
			}
			item.data("text", cacheValue.text);
			
			var text = item.find(".item-caption");
			// TODO: ovo baš i nije točno.
			text.html(cacheValue.text);
		},
		_addItem: function (data) {
			var that = this;	
			
			if(that.onlyOneElement){
				var obj = null;	
				var dataJSON = $("[name='" + this.name + "']").val();
				if(dataJSON != ""){
					obj = JSON.parse(dataJSON);	

					if(obj.length > 0){
						if(obj.length == 1){
							if(((obj[0].left != undefined) && (obj[0].op != undefined) && (obj[0].right === undefined)) || ((obj[0].left == undefined) && (obj[0].op != undefined) && (obj[0].right === undefined))){
								that.vratiItem = true;								
							}
							else{
								that.vratiItem = false;	
							}
						}
						else{
							that.vratiItem = false;
						}
					}
					else{
						that.vratiItem = true;	
					}
				}
			}				
			
			if((that.vratiItem)){				
				var item = $("<li>");
				item.addClass("item-value");
				item.addClass("k-button");
				
				var text = $("<span>");
				text.addClass("item-caption");
				item.append(text);
				
				// Event u kojem se poziva šifarnik nakon klika na kućicu.
				if (that.isSifarnik) {
					// Ako postavim na item.click, to uključuje i close span.
					item.click(function (event) {
						that._dohvatiSifarnik(function (data) {					
							that._itemSetData(item, data);
						});
					});
				}

				var close = $("<span class='px-1'>");				
				close.html("×");
				
				close.click(function (event) {
					event.stopPropagation();
					var parentItem = $(this).closest("li");
					that._remove(parentItem);
				});
				
				item.append(close);
				
				if (that.itemFilter) 
					that.itemFilter.before(item);
				else
					that.items.append(item);
				if (!(typeof data === "undefined" || data == null)) 
					that._itemSetData(item, data);
				
				that._updateInput();
				
				that.options.change.call(that, { action: "add", type: "item" });
				
				if(that.onlyOneElement){
					var obj = null;	
					var dataJSON = $("[name='" + this.name + "']").val();
					if(dataJSON != ""){
						obj = JSON.parse(dataJSON);	
	
						if(obj.length > 0){
							that.hideButtons();
						}
						else{
							that.unHideButtons();
						}
					}					
				}

				return item;		
			}
			else{
				return false;
			}
		},
		_remove: function (el) {
			var that = this;
			if (that._isLastItem(el[0])) {
				that._removeItem(el);
			}
			else {
				// Da li će nakon brisanja izraz biti valjan?
				// Testiram na incomplete regex.
				var reg = that._getItemsRegex(el);
				if (inputRegexIncomplete.test(reg)) {
					that._removeItem(el);
				}
				/*
				if (that.isValid(reg)) {
					that._removeItem(el);
				}
				 */
			}
		},
		_removeItem: function (el) {
		    var type = el.hasClass("operator") ? "op" : "item";
			el.remove();
			this._updateInput();
			this.options.change.call(this, { action: "delete", type: type });
			if(this.onlyOneElement){
				if(type == "item"){			
					var reg = this._getItemsRegex();			
					if (reg.length > 0 && reg[reg.length - 1] != "v"){
						if(this.dataType == "date"){
							this.opUntil.parent().removeClass("hide");
						}
						else{
							this.opUntil.removeClass("hide");	
						}											
					}	
				}
				else{
					this.hideButtons();
				}																				
			}	
			this._clean();				
		},
		_removeLast: function (el) {
			var el = this._getLastItem();
			this._remove(el);
		},
		_clean: function () {
			var gg = this.items.find("li.item-value");
			if(gg.length == 0){
				this.clear();				
			}
		},		
		_addOp: function (operator) {
			var that = this;
			
			if((that.onlyOneElement) && (operator == "add")){
				return false;
			}			

			var op = $("<li>");
			op.addClass("operator");
			op.addClass(operator);
			op.html(operator == "add" ? "," : "-");
			op.click(function () {
				that._remove($(this));
				if(that.onlyOneElement){
					that.hideButtons();
				}
			});
			
			if (that.itemFilter)
				that.itemFilter.before(op);
			else
				that.items.append(op);
		
			that._updateInput();
			that.options.change.call(that, { action: "add", type: "op" });

			if(that.onlyOneElement){
				var obj = null;	
				var dataJSON = $("[name='" + this.name + "']").val();
				if(dataJSON != ""){
					obj = JSON.parse(dataJSON);	

					if(obj.length > 0){
						if(that.inputType == "date"){
							that.opUntil.parent().removeClass("hide");
						}
						else{
							that.opUntil.removeClass("hide");
						}
					}
				}					
			}			
		},
		_getSifarnikPath: function(){
			var that = this;
			var path = that.element.data("path");
			var pathParam = that.element.data("path-param");
			if (pathParam){ 
				var calValue = eval(pathParam);
				for (i=0; i<calValue.length; i++){
					path += "/" + calValue[i]; 	
				}
			}
			return path;
		},
		_dohvatiSifarnik: function (onOdabir) {
			var that = this;
			var path = that._getSifarnikPath();
			konto.dialogs.sifarnik({
			    template: kontorouter.getModulPath(path),
			    odabir: function (data) {
			    	if(typeof data === "object")
		    			data = $.dsObjectToUpperCase(data);
				    	
			        onOdabir(data);
			        that._updateInput();
			    },
			    data: {
			        filter: that._getFilter()
			    }
			});
		},
		/**
		 * Vraća caption itema. Npr. za BL vraća Blagajna.
		 * */
		_getItemCaption: function (data) {
			if (this.isSifarnik) {
				if (this.options.onGetCaption) {			
					return this.options.onGetCaption.call(this, data);
				}
				else {
					return data ? data[this.searchColumn] : null;
				}
			}
			return null;
		},
		/**
		 * Vraća cijeli text koji će se zapisati u kućicu. Npr. za BL vraća BL - Blagajna.
		 * */
		_getItemText: function (data) {
				    							    									    									
			if (this.options.onGetText)
			{	
				if(typeof data === "object")
					data = $.dsObjectToUpperCase(data);
							
				return this.options.onGetText.call(this, data);
			}
			else if (this.options.onGetCaption)
				return data[this.pkColumn] + " - " + this.options.onGetCaption.call(this, data);
			else if (this.dataType == "date")
				return KUtils.formatDate(data);
			else if (this.dataType == "int")
				return data;
			else if (this.dataType == "string")
				return data;
			else
				return data[this.pkColumn];
		},
		/**
		 * Vraća regex iz sadržaja itemsa. 
		 * Za operatore vraća "a" (add) i "d" (do), a za
		 * vrijednosti "v".
		 */
		_getItemsRegex: function (exclude) {
			var that = this;
			var newArray = that.items.find("li").map(function (index, el, arr) {
				var $el = $(el);
				if (exclude && el == exclude[0])
					return "";
				
				if ($el.hasClass("operator")) {
					return $el.hasClass("add") ? "a" : "d";
				}
				else if ($el.hasClass("item-value")) {
					return "v";
				}
				else
					return "";
			});
			
			newArray = $.makeArray(newArray);
			return newArray.join("");
		},
		/**
		 * Vraća regex iz sadržaja, ali bez zamjene za operatore.
		 * */
		_getItemsRegexRaw: function (exclude) {
			var that = this;
			var newArray = that.items.find("li").map(function (index, el, arr) {
				var $el = $(el);
				if (exclude && el == exclude[0])
					return "";
				
				if ($el.hasClass("operator")) {
					return $el.hasClass("add") ? "," : "..";
				}
				else if ($el.hasClass("item-value")) {
					return $el.data("id");
				}
				else
					return "";
			});
			
			newArray = $.makeArray(newArray);
			return newArray.join("");
		},
		_getFilter: function () {
			var that = this;
			if (that.filter) {
				if (that.filter.val() != "") {
					var filter = {};
					filter.logic = "and";
					filter.filters = [{
						operator: "contains",
						value: that.filter.val(),
						field: that.searchColumn
					}];
					that.filter.val("");
					return filter;
				}
			}
			return null;
		},
		_processFilterValue: function () {			
		
		},
		_updateInput: function () {
			var that = this;
			var items = that.items.find("li").map(function (index, el, arr) {
				var $el = $(el);
				if ($el.hasClass("operator")) {
					return $el.hasClass("add") ? new AddOperator() : new UntilOperator();
				}
				else if ($el.hasClass("item-value")) {
					return new ItemValue($el.data("id"), $el.data("caption"), $el.data("text"));
				}
			});
			
			// Idem po itemima i vraćam vrijednosti u željenom obliku.
			var currObj = null;
			var objects = [];
			for (var i = 0; i < items.length; ++i) {
				var item = items[i];
				if (item instanceof AddOperator) {
					if (currObj !== null) {						
						objects.push(currObj);
					}
					currObj = null;
				}
				else {
					if (currObj === null)
						currObj = {};
					if (item instanceof UntilOperator) {
						currObj.op = "until";
					}
					else if (item instanceof ItemValue) {
						if (item.value instanceof Date) {
							item.value.setHours(item.value.getHours() - item.value.getTimezoneOffset() / 60);
						}
						
						if (!currObj.op) {
							currObj.left = { 
								value: item.value,
								caption: item.caption,
								text: item.text
							};
						}
						else { 
							currObj.right = {
								value: item.value,
								caption: item.caption,
								text: item.text
							};
						}
					}
					else {
						// nepoznati tip
					}
				}
			}
			
			if (currObj !== null) {
				objects.push(currObj);
			}
			if (objects.length == 0)
				that.input.val("");
			else
				that.input.val(JSON.stringify(objects));
		},
		/**
		 * Provjerava da li na trenutno regex (_getItemsRegex()) može dodati 
		 * vrijednosti navedene u exp parametru (npr. vd, av i slično)
		 * */
		_canAppend: function (exp) {
			var reg = this._getItemsRegex();
			reg += exp;
			return this.isValid(reg);
		},
		addItem: function (data) {
			var canAppend = this._canAppend("v");
			if (!canAppend) {
				canAppend = this._canAppend("av");
				if (canAppend)
					this._addOp("add");
				else
					return false;
			}
			this._addItem(data);
			return true;
		},
		addItemOd: function (data) {
			if (!this._canAppend("vd"))
				return false;
			this._addItem(data);
			this._addOp("until");
			return true;
		},
		addItemDo: function (data) {
			if (!this._canAppend("dv")) 
				return false;
			this._addOp("until");
			this._addItem(data);
		},
		addItemOdDo: function (data1, data2) {
			if (!this._canAppend("vdv"))
				return false;
			this._addItem(data1);
			this._addOp("until");
			this._addItem(data2);
			return true;
		},
		addOp: function (op) {
			this._addOp(op);
		},
		isValid: function (regex) {
			if (typeof regex === "undefined") {
				regex = this._getItemsRegex();
			}
			var match = inputRegex.test(regex);
			return match;
		},
		clear: function () {
			var that = this;
			that.items.find("li.item-value,li.operator").remove();
			that._updateInput();
			that._postaviNullNaDefault();
			that.unHideButtons();
			that.vratiItem = true;		
		},
		hideButtons: function () {
			if(this.onlyOneElement){
				if(this.inputType == "date"){
					this.opFrom.parent().addClass("hide");														
					this.opUntil.parent().addClass("hide");	
					this.opAdd.parent().addClass("hide");						
				}
				else{
					this.opFrom.addClass("hide");														
					this.opUntil.addClass("hide");	
					this.opAdd.addClass("hide");					
				}
			}				
		},		
		unHideButtons: function () {
			if(this.onlyOneElement){
				if(this.inputType == "date"){
					this.opFrom.parent().removeClass("hide");														
					this.opUntil.parent().removeClass("hide");	
					this.opAdd.parent().removeClass("hide");					
				}
				else{				
					this.opFrom.removeClass("hide");														
					this.opUntil.removeClass("hide");	
					this.opAdd.removeClass("hide");
				}																	
			}										
		},
		setFromCache: function (value) {
			var that = this;
			var changeFunc = that.options.change;
			that.options.change = function () { };
			try {
    			var values = JSON.parse(value);
    			if (values) {
    				for (var i = 0; i < values.length; ++i) {
    					var v = values[i];
    					if (v.left) {
    						var itemValue = v.left;
    						var item = that._addItem(itemValue.value, itemValue.caption);
    						that._itemSetDataFromCache(item, itemValue);
    					}
    					if (v.op) {
    						that._addOp("until");
    					}
    					if (v.right) {
    						var itemValue = v.right;
    						var item = that._addItem(itemValue.value, itemValue.caption);
    						that._itemSetDataFromCache(item, itemValue);
    					}
    					
    					if (i < values.length - 1) {
    						that._addOp("add");
    					}
    				}
    				that._updateInput();
    			}
			} finally {
			    that.options.change = changeFunc;
			}
			that.options.change.call(that, { action: "cache" });
		},
		/**
		 * Vraća boolean ako se unutar komponente samo nalazi vrijednost.
		 */
		hasOnlyOneItem: function () {
	       var regex = this._getItemsRegex();
	       return regex === "v";	    
		}
	});
	
	ui.plugin(KontoIspis);
} (jQuery));